
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"36","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none"}},[_c('rect',{attrs:{"width":"36","height":"24","fill":"#F2F0EC","rx":"4"}}),_c('path',{attrs:{"fill":"#F26122","d":"M14.175 5.745h7.657v12.51h-7.657z"}}),_c('path',{attrs:{"fill":"#EA1D25","d":"M15 12a7.934 7.934 0 013-6.255 7.957 7.957 0 100 12.51A7.932 7.932 0 0115 12z"}}),_c('path',{attrs:{"fill":"#F69E1E","d":"M30.155 17.03v-.34h.15v-.07h-.35v.07h.14v.34h.06zm.68 0v-.41h-.1l-.12.29-.13-.29h-.1v.41h.07v-.31l.12.27h.08l.11-.27v.31h.07zM30.87 12A7.957 7.957 0 0118 18.255a7.957 7.957 0 001.335-11.167A7.819 7.819 0 0018 5.745a7.955 7.955 0 018.39-.897A7.955 7.955 0 0130.87 12z"}})])])
          )
        }
      }
    